import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import ErrorOutline from '@mui/icons-material/ErrorOutline';

const Page = styled.div`
  max-width: 480px;
  margin: 0 auto;
  padding: 32px 16px 48px;
`;

const Card = styled.div`
  background: #fff;
  border: 1px solid #fecaca;
  border-radius: 16px;
  padding: 28px 22px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(220, 38, 38, 0.06);
`;

const IconWrap = styled.div`
  width: 56px;
  height: 56px;
  margin: 0 auto 16px;
  border-radius: 50%;
  background: #fef2f2;
  color: #dc2626;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Title = styled.h1`
  font-size: 1.2rem;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 12px;
`;

const Message = styled.p`
  font-size: 14px;
  color: #475569;
  line-height: 1.55;
  margin: 0 0 8px;
  text-align: left;
  word-break: break-word;
`;

const Meta = styled.p`
  font-size: 13px;
  color: #94a3b8;
  margin: 0 0 22px;
`;

const Hint = styled.p`
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
  margin: 0 0 20px;
  text-align: left;
  padding: 12px 14px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
`;

const BackLink = styled.button`
  width: 100%;
  padding: 14px 20px;
  border: none;
  border-radius: 12px;
  background: #1d2340;
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  &:hover {
    filter: brightness(1.05);
  }
`;

const PaymentFail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const code = searchParams.get('code');
  const message = searchParams.get('message');

  return (
    <Page>
      <Card>
        <IconWrap>
          <ErrorOutline style={{ fontSize: 32 }} aria-hidden />
        </IconWrap>
        <Title>결제가 완료되지 않았습니다</Title>
        {message && <Message>{decodeURIComponent(message)}</Message>}
        {code && <Meta>코드: {code}</Meta>}
        <Hint>
          카드 한도·결제 중단·창 닫기 등으로 실패할 수 있습니다. 수단을 확인한 뒤 결제 관리에서 다시 시도해
          주세요.
        </Hint>
        <BackLink type="button" onClick={() => navigate('/payment')}>
          결제 관리로 돌아가기
        </BackLink>
      </Card>
    </Page>
  );
};

export default PaymentFail;
